// Apresentação das cotações de frete (pedido de venda e Pedido de Entrega).
//
// A opção "Entrega própria (sem cotação)" da Viver Organizer é acrescentada pelo ERPApi quando o
// endereço de entrega fica em SP e o FreightHub não cotou a frota própria — ver
// ERPApi/internal/core/domain/own_fleet_manual_quote.go. Ela não tem valor nem prazo: mostrar
// "R$ 0,00" e "0 dias úteis" faria parecer frete grátis.

/** Mesmo texto de domain.OwnFleetManualServiceName no ERPApi — manter em sincronia. */
export const OWN_FLEET_MANUAL_SERVICE_NAME = 'Entrega própria (sem cotação)';

/** domain.ShippingProviderIDViverOrganizer (frota própria). */
export const VIVER_ORGANIZER_PROVIDER_ID = 1;

export interface FreightQuoteDisplayInput {
  provider_id?: number | null;
  provider_service_name?: string | null;
  cost?: number | null;
  delivery_days?: number | null;
  is_manual?: boolean;
}

/** Opção manual da frota própria. Usa is_manual da API e, na falta dele, o nome do serviço. */
export const isManualFreightQuote = (quote: FreightQuoteDisplayInput): boolean =>
  quote.is_manual === true ||
  (quote.provider_id === VIVER_ORGANIZER_PROVIDER_ID &&
    (quote.provider_service_name ?? '').trim() === OWN_FLEET_MANUAL_SERVICE_NAME);

export const formatFreightQuoteCost = (quote: FreightQuoteDisplayInput): string =>
  isManualFreightQuote(quote)
    ? 'Sem valor'
    : (quote.cost ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const formatFreightQuoteDays = (quote: FreightQuoteDisplayInput): string => {
  if (isManualFreightQuote(quote)) return 'A combinar';
  const days = quote.delivery_days ?? 0;
  return `${days} ${days === 1 ? 'dia útil' : 'dias úteis'}`;
};
